import React from "react";
import { makeStyles } from "@material-ui/styles";
import GridContainer from "../../components/GridContainer";
import GridItem from "../../components/GridItem";
import multiLang from "../../lang/lang.json";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import { Instagram, SnapChat, WhatsApp, Twitter, YouTube } from "../icons";

const departs = {
  1: [
    "Handicrafts",
    "Digital Device",
    "Transportation",
    "Clothing",
    "jewerly",
    "Vehicle",
    "Furniture"
  ],
  2: [
    "Cosmetics",
    "Fashion",
    "Houseware",
    "Art",
    "Sport",
    "Travel",
    "Business"
  ],
  3: [
    "Entertainment",
    "Media",
    "Commerce",
    "Education",
    "Agriculture",
    "Health",
    "Home"
  ],
  4: ["Kids & Teenagers", "News", "Science", "Shopping"]
};

const useStyles = makeStyles({
  root: {
    backgroundColor: "#2b2b2b",
    color: "#fff"
  },
  grid: {
    display: "grid",
    paddingBottom: "20px",
    "& h4": {
      textTransform: "uppercase"
    }
  },
  copy: {
    margin: "0 auto",
    paddingTop: "20px",
    paddingBottom: "20px"
  },
  TextField: {
    width: "300px !important",
    "@global": {
      ".Mui-focused": {
        color: "#5f5f5f"
      },
      fieldset: {
        borderRadius: "0",
        borderColor: "#5f5f5f !important"
      },
      input: {
        color: "red"
      },
      label: {
        color: "#5f5f5f"
      }
    }
  },
  link: {
    color: "#989898",
    margin: "7px 0"
  },
  button: {
    backgroundColor: "#524f4f",
    color: "white",
    borderRadius: "0",
    padding: "16px 50px",
    margin: "16px"
  }
});

const Footer = ({ language, categories }) => {
  const classes = useStyles();
  const { lang, dir } = language;
  return (
    <div className={`${classes.root} ${dir === "rtl" ? "rtl" : "ltr"}`}>
      <GridContainer>
        <GridItem xs={6} sm={3} md={3}>
          <div className={classes.grid}>
            <h4>{multiLang["004"][lang]}</h4>
            <Link className={classes.link} href={"/about"}>
              {multiLang["053"][lang]}
            </Link>
            <Link className={classes.link} href={"/about"}>
              {multiLang["070"][lang]}
            </Link>
          </div>
        </GridItem>
        <GridItem xs={6} sm={3} md={3}>
          <div className={classes.grid}>
            <h4>{multiLang["005"][lang]}</h4>
            <Link className={classes.link}>{"+018 900 6690"}</Link>
          </div>
        </GridItem>
        <GridItem xs={6} sm={3} md={3}>
          <div className={classes.grid}>
            <h4>{multiLang["068"][lang]}</h4>
            {/* <Link className={classes.link}>{"+018 900 6690"}</Link> */}
          </div>
        </GridItem>
        <GridItem xs={6} sm={3} md={3}>
          <div className={classes.grid}>
            <h4>{multiLang["069"][lang]}</h4>
            {/* <Link className={classes.link}>{"+018 900 6690"}</Link> */}
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer style={{ borderTop: "1px solid" }}>
        <GridItem xs={12} sm={6} md={6}>
          <div className={classes.grid}>
            <h4>{multiLang["006"][lang]}</h4>
            <div>
              <Instagram />
              <SnapChat />
              <WhatsApp />
              <Twitter />
              <YouTube />
            </div>
          </div>
        </GridItem>
        <GridItem xs={12} sm={6} md={6}>
          <div className={classes.grid}>
            <h4>{multiLang["007"][lang]}</h4>
            <div>
              <TextField
                className={classes.TextField}
                label={multiLang["008"][lang]}
                margin="normal"
                variant="outlined"
              />
              <Button variant="contained" className={classes.button}>
                {multiLang["009"][lang]}
              </Button>
            </div>
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer style={{ borderTop: "1px solid", padding: "20px 0" }}>
        <GridItem xs={6} sm={3} md={3}>
          <div className={classes.grid}>
            {departs[1].map((dep, i) => (
              <Link key={i} className={classes.link} href={"/"}>
                {dep}
              </Link>
            ))}
          </div>
        </GridItem>
        <GridItem xs={6} sm={3} md={3}>
          <div className={classes.grid}>
            {departs[2].map((dep, i) => (
              <Link key={i} className={classes.link} href={"/"}>
                {dep}
              </Link>
            ))}
          </div>
        </GridItem>
        <GridItem xs={6} sm={3} md={3}>
          <div className={classes.grid}>
            {departs[3].map((dep, i) => (
              <Link key={i} className={classes.link} href={"/"}>
                {dep}
              </Link>
            ))}
          </div>
        </GridItem>
        <GridItem xs={6} sm={3} md={3}>
          <div className={classes.grid}>
            {departs[4].map((dep, i) => (
              <Link key={i} className={classes.link} href={"/"}>
                {dep}
              </Link>
            ))}
          </div>
        </GridItem>
        <div className={classes.copy}>
          &copy;{" "}
          {`${new Date().getFullYear()} ${multiLang["001"][lang]} ${
            multiLang["002"][lang]
          }`}
        </div>
      </GridContainer>
    </div>
  );
};

export default Footer;
